import { motion } from 'framer-motion'
import { useEffect, useState, useMemo } from 'react'
import onboardingGradient2 from '@assets/backgrounds/onboarding/onboarding-gradient-2.webp'

export const OnboardingBackground = () => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 2500)

    return () => clearTimeout(timer)
  }, [])

  // Memoize animation objects to prevent recreation on every render
  const backgroundAnimation = useMemo(
    () => ({
      initial: { opacity: 0 },
      animate: { opacity: isVisible ? 1 : 0 },
      transition: { duration: isVisible ? 0.3 : 1.2 },
    }),
    [isVisible],
  )

  const contentAnimation = useMemo(
    () => ({
      initial: { opacity: 0 },
      animate: { opacity: isVisible ? 1 : 0 },
      transition: { delay: isVisible ? 0.15 : 0, duration: isVisible ? 0.4 : 0.6 },
    }),
    [isVisible],
  )

  const imageAnimation = useMemo(
    () => ({
      initial: { opacity: 0.8 },
      animate: { opacity: isVisible ? [0.8, 0.6, 0.8] : 0 },
      transition: {
        duration: isVisible ? 12 : 1.2,
        repeat: isVisible ? Infinity : 0,
        ease: 'easeInOut',
      },
    }),
    [isVisible],
  )

  return (
    <motion.div className="fixed inset-0 z-0 bg-black/95" {...backgroundAnimation}>
      <motion.div className="absolute bottom-0 left-0 right-0 w-full" {...contentAnimation}>
        <motion.img
          src={onboardingGradient2}
          alt="Onboarding background gradient"
          className="h-auto w-full object-cover"
          style={{ height: '696px' }}
          {...imageAnimation}
        />
      </motion.div>
    </motion.div>
  )
}
